"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require("styled-system");

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _themed = require("../../utils/themed");

var _themed2 = _interopRequireDefault(_themed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const disabled = p => p.disabled ? " pointer-events: none; opacity: 0.5;" : "";

const StyledButton = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Button__StyledButton",
  componentId: "moa6v7-0"
})(["cursor:pointer;", " ", " ", " &:focus{box-shadow:0 0 10 0 rgba(0,0,0,0.2);outline:none;}transition:all ", " ", ";"], (0, _themed2.default)("Button"), _styledSystem.buttonStyle, disabled, p => p.theme.duration[2], p => p.theme.transition.default);

const Button = props => {
  return _react2.default.createElement(StyledButton, props);
};

Button.propTypes = _extends({}, _styledSystem.buttonStyle.propTypes);

Button.defaultProps = {
  as: "button",
  fontSize: 1,
  m: 0,
  px: 3,
  py: 2,
  variant: "orange",
  border: 0,
  borderRadius: 4
};

/** @component */
exports.default = Button;